/**
 * region for libraries*/
import React, { Component } from "react";
import MUIDataTable from "mui-datatables";
import {
  Tabs,
  Tab,
  AppBar,
  Typography,
  Button,
  IconButton,
  Tooltip,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Chip,
} from "@material-ui/core";

/**
 * region for icons*/
import DeleteIcon from "@material-ui/icons/Delete";
import AddIcon from "@material-ui/icons/Add";
import EditIcon from "@material-ui/icons/Edit";

/**
 * region for components*/
import LayoutIdentifySupplierJobs from "../../scrapy/LayoutIdentifySupplierJobs";
import { ResearchKeywordSelection } from "../../suppliers/research/ResearchKeywordSelection";

/**
 * region for helpers*/
import ajax from "../../../helpers/ajax";
import typing from "../../../helpers/typing";

/**
 * region for constans*/
import Constants from "../../../constants/Constants";

export class ResearchList extends Component {
  static displayName = ResearchList.name;

  constructor(props) {
    super(props);

    this.state = {
      selectedTab: 3,
      dataQueue: [],
      dataProcessed: [],
      dataResult: [],
      dataAllowedDomains: [],
      open: false,
      idDomain: "",
      domain: "",
      domainEmpy: false,
      edit: false,
    };
  }

  loadDataAllowedDomain() {
    this.researchTaskDataAllowedDomain(4);
  }

  researchTaskDataQueue(newValue) {
    const self = this;

    let requestData = {
      idResearchStatus: Constants.RESEARCH_TASKS_STATUS.Queued,
    };

    ajax.get(Constants.ROUTE_API_RESEARCH_TASK, {
      requestData: requestData,
      success: function (response) {
        var dataQueue = [];

        response.data.forEach((row) => {
          dataQueue.push({
            date: typing.convertToDateShortMonthWithTime(row.DATEADDED),
            user: row.USER,
            term: row.TERM,
            idType: row.IDTYPE,
            remove: (
              <Button onClick={self.handleDeleteRow.bind(self, row)}>
                <DeleteIcon />
              </Button>
            ),
          });
        });

        self.setState({
          dataQueue: dataQueue,
          selectedTab: newValue,
        });
      },
    });
  }

  researchTaskDataProcessed(newValue) {
    const self = this;

    let requestData = {
      idResearchStatus: Constants.RESEARCH_TASKS_STATUS.Processed,
    };

    ajax.get(Constants.ROUTE_API_RESEARCH_TASK, {
      requestData: requestData,
      success: function (response) {
        var dataProcessed = [];

        response.data.forEach((row) => {
          dataProcessed.push({
            dateAdded: typing.convertToDateShortMonthWithTime(row.DATEADDED),
            dateProcessed: typing.convertToDateShortMonthWithTime(
              row.DATEPROCESSED
            ),
            user: row.USER,
            term: row.TERM,
            idType: row.IDTYPE,
          });
        });

        self.setState({
          dataProcessed: dataProcessed,
          selectedTab: newValue,
        });
      },
    });
  }

  researchTaskDataAllowedDomain(newValue) {
    const self = this;

    ajax.get(Constants.ROUTE_API_RESEARCH_RESULT_NOT_ALLOWED_DOMAIN, {
      success: function (response) {
        var dataAllowedDomains = [];

        response.data.forEach((row) => {
          dataAllowedDomains.push({
            IdResearchResultsNotAllowedDomains:
              row.IDRESEARCHRESULTSNOTALLOWEDDOMAINS,
            domain: row.DOMAIN,
            remove: (
              <div className="text-right">
                <Button
                  onClick={self.handleAllowedDomainsEditRow.bind(self, row)}
                >
                  <EditIcon />
                </Button>
                <Button
                  onClick={self.handleAllowedDomainsDeleteRow.bind(self, row)}
                >
                  <DeleteIcon />
                </Button>
              </div>
            ),
          });
        });

        self.setState({
          dataAllowedDomains: dataAllowedDomains,
          selectedTab: newValue,
        });
      },
    });
  }

  handleTabClick(event, newValue) {
    if (newValue === 0) {
      this.setState({
        selectedTab: newValue,
      });
    } else if (newValue === 1) {
      this.researchTaskDataQueue(newValue);
    } else if (newValue === 2) {
      this.researchTaskDataProcessed(newValue);
    } else if (newValue === 3) {
      this.setState({
        selectedTab: newValue,
      });
    } else {
      this.researchTaskDataAllowedDomain(newValue);
    }
  }

  handleDeleteRow(row, event) {
    event.preventDefault();
    event.stopPropagation();

    const self = this;

    let requestData = {
      idResearchTask: row.IDRESEARCHTASK,
    };

    ajax.delete(Constants.ROUTE_API_RESEARCH_TASK, {
      requestData: requestData,
      success: function (response) {
        self.load();
      },
    });
  }

  handleDeleteAll(event) {
    event.preventDefault();
    event.stopPropagation();

    const self = this;

    ajax.delete(Constants.ROUTE_API_RESEARCH_TASK_DELETE_ALL, {
      success: function (response) {
        self.load();
      },
    });
  }

  handleAllowedDomainsDeleteRow(row, event) {
    event.preventDefault();
    event.stopPropagation();

    const self = this;

    let requestData = {
      idResearchResultsNotAllowedDomains:
        row.IDRESEARCHRESULTSNOTALLOWEDDOMAINS,
    };

    ajax.delete(Constants.ROUTE_API_RESEARCH_RESULT_NOT_ALLOWED_DOMAIN, {
      requestData: requestData,
      success: function (response) {
        self.loadDataAllowedDomain();
      },
    });
  }

  handleAllowedDomainsShowDialog(event) {
    event.preventDefault();
    this.setState({
      open: true,
      domain: "",
      idDomain: "",
      edit: false,
    });
  }

  handleAllowedDomainsCloseDialog(event) {
    event.preventDefault();
    this.setState({
      open: false,
      domain: "",
      idDomain: "",
    });
  }

  handleAllowedDomainsSave(event) {
    event.preventDefault();
    let self = this;
    if (typing.isEmpty(self.state.domain)) {
      self.setState({
        domainEmpy: true,
      });
    } else {
      let requestData = {
        idResearchResultsNotAllowedDomains: self.state.idDomain,
        domain: self.state.domain,
      };

      if (self.state.edit) {
        ajax.put(Constants.ROUTE_API_RESEARCH_RESULT_NOT_ALLOWED_DOMAIN, {
          requestData: requestData,
          success: function (response) {
            self.setState(
              {
                open: false,
                domain: "",
                domainEmpy: false,
              },
              function () {
                self.loadDataAllowedDomain();
              }
            );
          },
        });
      } else {
        ajax.post(Constants.ROUTE_API_RESEARCH_RESULT_NOT_ALLOWED_DOMAIN, {
          requestData: requestData,
          success: function (response) {
            self.setState(
              {
                open: false,
                domain: "",
                domainEmpy: false,
              },
              function () {
                self.loadDataAllowedDomain();
              }
            );
          },
        });
      }
    }
  }

  handleAllowedDomainsChange(event) {
    event.preventDefault();
    this.setState({
      domain: event.target.value,
    });
  }

  handleAllowedDomainsEditRow(row, event) {
    event.preventDefault();
    this.setState({
      open: true,
      edit: true,
      domain: row.DOMAIN,
      idDomain: row.IDRESEARCHRESULTSNOTALLOWEDDOMAINS,
    });
  }

  render() {
    const dataQueue = this.state.dataQueue;

    const columnsQueue = [
      { name: "date", label: "Date" },
      { name: "user", label: "User" },
      { name: "term", label: "Term" },
      { name: "idType", label: " " },
      {
        name: "remove",
        label: "Remove All",
        options: {
          align: "right",
          customHeadRender: (columnMeta) => (
            <th
              key={columnMeta.name}
              className="MuiTableCell-root MuiTableCell-head MUIDataTableHeadCell-root-303"
              scope="col"
            >
              {columnMeta.label}
              <Button onClick={this.handleDeleteAll.bind(this)}>
                <DeleteIcon />
              </Button>
            </th>
          ),
        },
      },
    ];
    const optionsQueue = {
      print: false,
      download: false,
      viewColumns: false,
      filter: false,
      sort: false,
      selectableRows: false,
      textLabels: {
        pagination: {
          next: "Next Page",
          previous: "Previous Page",
          rowsPerPage: "Rows per page:",
          displayRows: "of",
        },
      },
      fixedHeader: false,
      customRowRender: (data) => {
        const [date, user, term, idType, remove] = data;
        let labelType = Constants.RESEARCH_LIST_TYPE.find(
          (x) => x.id === idType
        ).text;
        return (
          <tr key={term} className="MuiTableRow-root MuiTableRow-hover">
            <td className="MuiTableCell-root MuiTableCell-body">{date}</td>
            <td className="MuiTableCell-root MuiTableCell-body">{user}</td>
            <td colSpan={2} className="MuiTableCell-root MuiTableCell-body">
              <div className="pull-left">{term}</div>
              <div className="ml-1 pull-left">
                <Chip label={labelType} size="small" />
              </div>
            </td>
            <td className="MuiTableCell-root MuiTableCell-body">{remove}</td>
          </tr>
        );
      },
    };

    const dataProcessed = this.state.dataProcessed;

    const columnsProcessed = [
      { name: "dateAdded", label: "Date added" },
      { name: "dateProcessed", label: "Date processed" },
      { name: "user", label: "User" },
      { name: "term", label: "Term" },
      { name: "idType", label: " " },
    ];

    const optionsProcessed = {
      print: false,
      download: false,
      viewColumns: false,
      filter: false,
      sort: false,
      selectableRows: false,
      customRowRender: (data) => {
        const [dateAdded, dateProcessed, user, term, idType] = data;
        let labelType = Constants.RESEARCH_LIST_TYPE.find(
          (x) => x.id === idType
        ).text;
        return (
          <tr key={term} className="MuiTableRow-root MuiTableRow-hover">
            <td className="MuiTableCell-root MuiTableCell-body">{dateAdded}</td>
            <td className="MuiTableCell-root MuiTableCell-body">
              {dateProcessed}
            </td>
            <td className="MuiTableCell-root MuiTableCell-body" width="75">
              {user}
            </td>
            <td
              colSpan={2}
              className="MuiTableCell-root MuiTableCell-body"
              width="480"
            >
              <div className="pull-left">{term}</div>
              <div className="ml-1 pull-left">
                <Chip label={labelType} size="small" />
              </div>
            </td>
          </tr>
        );
      },
    };

    const dataAllowedDomains = this.state.dataAllowedDomains;

    const columnsAllowedDomains = [
      { name: "domain", label: "Domain name" },
      {
        name: "remove",
        label: "  ",
      },
    ];

    const optionsAllowedDomains = {
      print: false,
      download: false,
      viewColumns: false,
      filter: false,
      sort: false,
      selectableRows: false,
      customToolbar: () => {
        return (
          <Tooltip title={"Add Domain"}>
            <IconButton
              onClick={this.handleAllowedDomainsShowDialog.bind(this)}
            >
              <AddIcon />
            </IconButton>
          </Tooltip>
        );
      },
    };

    let textTab;
    if (this.state.selectedTab === 0) {
      textTab = "";
    } else if (this.state.selectedTab === 1) {
      textTab = "The following keywords are currently queued for researching.";
    } else if (this.state.selectedTab === 2) {
      textTab = "The following keywords have already been processed.";
    } else if (this.state.selectedTab === 3) {
      textTab =
        "The following list shows URLs that have been picked up from the research keywords that have been processed. Click on an item to load a preview.You can use the action buttons to discard the results or to open a ticket for the content team to load.";
    } else {
      textTab = "Results from the following domains will be excluded";
    }

    let error, errorText;
    if (this.state.domainEmpy) {
      error = true;
      errorText = "Please enter a domain";
    }

    let textEdit = "Add";
    if (this.state.edit) {
      textEdit = "Edit";
    }

    return (
      <div className="m-2">
        <Typography variant="h5" className="mb-1">
          Supplier research
        </Typography>
        <AppBar position="static" color="default" className="mb-2 tabs-menu">
          <Tabs
            value={this.state.selectedTab}
            indicatorColor="primary"
            onChange={this.handleTabClick.bind(this)}
            variant="standard"
          >
            <Tab label="Research" />
            <Tab label="Queue" />
            <Tab label="Processed" />
            <Tab label="Result" />
            <Tab label="Domain Blacklist" />
          </Tabs>
        </AppBar>
        <Typography variant="body1">{textTab}</Typography>
        {this.state.selectedTab === 0 && <ResearchKeywordSelection />}
        {this.state.selectedTab === 1 && (
          <MUIDataTable
            className="researchTable"
            data={dataQueue}
            columns={columnsQueue}
            options={optionsQueue}
          />
        )}
        {this.state.selectedTab === 2 && (
          <MUIDataTable
            className="researchTable"
            data={dataProcessed}
            columns={columnsProcessed}
            options={optionsProcessed}
          />
        )}
        {this.state.selectedTab === 3 && <LayoutIdentifySupplierJobs />}
        {this.state.selectedTab === 4 && (
          <MUIDataTable
            className="researchTable"
            data={dataAllowedDomains}
            columns={columnsAllowedDomains}
            options={optionsAllowedDomains}
          />
        )}
        <Dialog
          open={this.state.open}
          onClose={this.handleAllowedDomainsCloseDialog.bind(this)}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">{textEdit} Domain</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Enter the domain name to exclude. You can use * as a wildcard. Ex.
              *.nasa.gov
            </DialogContentText>
            <TextField
              error={error}
              helperText={errorText}
              autoFocus
              id="domain"
              label="Domain name"
              value={this.state.domain}
              onChange={this.handleAllowedDomainsChange.bind(this)}
              fullWidth
            />
          </DialogContent>
          <DialogActions>
            <Button
              color="primary"
              onClick={this.handleAllowedDomainsCloseDialog.bind(this)}
            >
              Cancel
            </Button>
            <Button
              color="primary"
              onClick={this.handleAllowedDomainsSave.bind(this)}
            >
              Save
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}
